import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DayHeaderContentArg } from '@fullcalendar/core';
import { FC } from 'react';
import moment from 'moment/moment';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { ScheduleFooter } from '../../Schedule/components';
import { useSchedulePermissions } from '../../Shared/hooks';

type TDayHeaderContentArg = {
  info: DayHeaderContentArg
};

const DayHeaderContent: FC<TDayHeaderContentArg> = ({ info }) => {
  const { text, sideText, date } = info;
  const { schedulePermissions } = useSchedulePermissions();
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <Box>
      <Box alignItems="center" display="flex" justifyContent="space-between">
        <Typography
          component="div"
          variant="subtitle2"
        >
          {text}
        </Typography>
        <Typography
          component="div"
          variant="subtitle2"
        >
          {' '}
          {sideText}
        </Typography>
      </Box>
      {schedulePermissions.isAllowViewSalaryData && isMobile
        && <ScheduleFooter isDayHeader selectedDate={moment(date).format()} />}
    </Box>
  );
};

export {
  DayHeaderContent,
};
